import React from "react";

export type CardVariant =
  | "default"
  | "border"
  | "glass"
  | "info"
  | "warning"
  | "danger";

export type CardSize = "small" | "medium";

export interface CardProps {
  children: React.ReactNode;
  variant?: CardVariant;
  size?: CardSize;
  className?: string;
  onClick?: (event: unknown) => void;
}

export const Card: React.FC<CardProps> = ({
  children,
  variant = "default",
  size = "medium",
  className = "",
  onClick,
}) => {
  const baseClasses = "rounded-lg border";

  const sizeClasses = {
    medium: "p-2 md:p-6",
    small: "p-2 md:p-2",
  };

  const variantClasses = {
    default:
      "border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]",
    border:
      "border-gray-300 bg-white bg-boxdark dark:bg-gray-900 dark:border-gray-700",
    glass:
      "border-gray-200/50 bg-white/50 backdrop-blur-sm dark:border-gray-800/50 dark:bg-white/[0.02]",
    info: "border-brand-200 bg-brand-50 dark:border-brand-800 dark:bg-brand-900/10",
    warning:
      "border-yellow-200 bg-yellow-50 dark:border-yellow-800 dark:bg-yellow-900/10",
    danger: "border-red-200 bg-red-50 dark:border-red-800 dark:bg-red-900/10",
  };

  return (
    <div
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className} ${
        onClick ? " cursor-pointer" : ""
      }`}
    >
      {children}
    </div>
  );
};
